import React from 'react';
import { faTimes, faSave } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface IPrintScheduleLaunchboxProps {
  onSave: () => void;
  onValidate: () => boolean;
  isLoading: boolean;
}

export function PrintScheduleLaunchbox(props: IPrintScheduleLaunchboxProps) {
  const { isLoading, onSave, onValidate } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  return (
    <FloatingActionButtonBar>
      <FloatingActionButton buttonText="Gem" icon={faSave} onClick={handleSave} />
      <FabDivider />
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
